import React from "react";
import ReactDOM from "react-dom";

import { root } from "baobab-react/higher-order";
import Baobab from "baobab";

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import * as playerActions from "./actions/playerActions";

import config from "./config/config";
import env from "./constants/env";
import state from "./state";

import smoothscroll from "smoothscroll-polyfill";
import _ from "lodash";

// kick off the polyfill!
smoothscroll.polyfill();

// global function for inline linking
window.playerActionsInlineLinkUrl = playerActions.inlineLinkUrl;

// Let's bind the component to the tree through the `root` higher-order component
let tree = new Baobab({});
const RootedApp = root(tree, App);

renderApp();

function renderApp() {
	// Rendering the app

	//passing in all params required by web player, simulate passing from external app by cloning state, config, and env
	ReactDOM.render(<RootedApp activities={activities} config={_.cloneDeep(config)} env={_.cloneDeep(env)} state={new Baobab(_.cloneDeep(state.get()))} />, document.getElementById("root")); // eslint-disable-line

	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: http://bit.ly/CRA-PWA
	serviceWorker.unregister();
}
